import React from 'react'
import '../styles/profilecard.css'
import {GrMail} from 'react-icons/gr'
import {BsLinkedin} from 'react-icons/bs'

/* Core Team Profile Cards in TEAM Page */


function ProfileCard({imgPath, Name, Desig, SMHandles,teamPath})
{

  
  return (
    
    <div className="card" >
        <img src={require(`../imagProps/${teamPath}/${imgPath}`)} className="Avatar" style={{width:'100%'}} loading="lazy" decoding="async" alt={Name} />
        {SMHandles && <div className="overlay">
        
        <a href={SMHandles} target='_blank' className="icon">
          <BsLinkedin />
        </a>
      </div>}
        <div className='middle'>
        
        </div>
        <div className="container">
            <h4><b>{Name}</b></h4>
            <p>{Desig}</p>
        </div>
    </div>
  )
}

export default ProfileCard
// import React from 'react';
// import '../styles/profilecard.css';
// import { GrMail } from 'react-icons/gr';
// import { BsLinkedin } from 'react-icons/bs';

// function ProfileCard({ imgPath, Name, Desig, SMHandles, teamPath }) {
  

//   let imageSrc;
//   try {
//     if (imgPath) {
//       imageSrc = require(`../imagProps/${teamPath}/${imgPath}`);
//     }
//   } catch (err) {

//     console.warn('Image not found:', imgPath);
//   }

//   return (
//     <div className="card">
//       {imageSrc && (
//         <img
//           src={imageSrc}
//           className="Avatar"
//           style={{ width: '100%' }}
//           alt={Name}
//         />
//       )}
//       {SMHandles && SMHandles[1] && (
//         <div className="overlay">
//           <a href={SMHandles[1]} className="icon" target="_blank" rel="noopener noreferrer">
//             <BsLinkedin />
//           </a>
//         </div>
//       )}
//       <div className='middle'></div>
//       <div className="container">
//         <h4><b>{Name}</b></h4>
//         <p>{Desig}</p>
//       </div>
//     </div>
//   );
// }

// export default ProfileCard;
